module.exports = __webpack_public_path__ + "img/light.8ed9b113.svg";